// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"paVBArQvgqZb7nQ1F8G2","titleSection":"SZlJ7iof5Ykcti3h8wcT"};